<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: "App",
		data() {
			return {
				ismove: false,
			};
		},
		mounted() {
			window.addEventListener('resize', this.sizeFun);
		},
		methods: {
			sizeFun() {
				// if (!this.$utile.locatFun('token')&&this.$route.name!='evaluationReport') {
				// 	var path = this.$route.name;
				// 	let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
				// 	if (/Mobi|Android|iPhone/i.test(navigator.userAgent) || window.innerWidth < 760) {
				// 		if (path != 'Login' && path != 'Signin' && path != 'Replace') {
				// 			this.$router.replace({
				// 				name: 'Login'
				// 			});
				// 		}
				// 	} else {
				// 		this.$router.push({
				// 			name: 'Common'
				// 		});
				// 	}
				// }
				if (/Mobi|Android|iPhone/i.test(navigator.userAgent) || window.innerWidth < 760) {
					this.ismove = true;
				} else {
					this.ismove = false;
				}
			},
		},
		created() {
			
		},
		watch: {
			'$route': function(val) {
				this.sizeFun();
			}
		},
	};
</script>

<style>
	#app {
		width: 100%;
		height: auto;
		min-height: 100%;
		background-color: #f6f7fa;
	}

	/* pc内页--中间区域 */
	.index_content {
		width: 1200px;
		margin: auto;
		box-sizing: border-box;
		padding: 20px 0 70px;
	}

	@media screen and (max-width:1200px) {
		.index_content {
			width: 100%;
		}
	}
</style>